<div class="error-message" *ngIf="campoObligatorioError">Hay campos obligatorios sin cubrir</div>
<div class="error-message" *ngIf="errorCamposIncorrectos && !campoObligatorioError">Hay campos introducidos incorrectamente</div>
<div class="ok-message fade-out" *ngIf="!campoObligatorioError && !errorCamposIncorrectos && dispositivoCreado !errorFinal">El tanque se ha editado correctamente</div>
<div class="error-message fade-out" *ngIf="errorFinal">{{errorMessage}}</div>

<!--<ng-container *ngIf="errorMessage !== ''">
    <div class="error-container">
        <div class="mensaje-error-container">
            <div class="mensaje-error">{{ errorMessage }}</div>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>-->

<div class="container">
    <div class="header">
        <div class="header-content">
            <span class="font20">EDITAR TANQUE</span>
            <button mat-icon-button matTooltip="Guardar cambios" class="gurdar-btn" (click)="guardarDispositivo()" [disabled]="waitAfterSave">
                <mat-icon>save</mat-icon>
            </button>
        </div>
        <span class="header-text font14">Formulario para editar tanques DataBeer</span>
    </div>

    <div class="body">

        <!--DATOS TANQUE-->

        <div class="datos-instalacion">
            <div class="datos-dispositivo-header">
                <span>DATOS DEL TANQUE</span>
            </div>

            <mat-form-field class="etiqueta-container marginTop20">
                <mat-label class="etiqueta-label">Identificador Único</mat-label>
                <input matInput type="text" [(ngModel)]="identificadorCliente" placeholder="Identificador del tanque">
                <button *ngIf="identificadorCliente" matSuffix mat-icon-button aria-label="Clear" (click)="identificadorCliente=''">
                  <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <form [formGroup]="customPositionFormGroup"  class="marginTopM15">
                <mat-form-field class="etiqueta-container">
                    <mat-label class="etiqueta-label" [ngClass]="{'error-select': customNumeroTanqueError}">Número de tanque</mat-label>
                    <input matInput type="text" formControlName="customPosition" placeholder="Número de tanque en el establecimiento">
                </mat-form-field>
                <mat-error *ngIf="customPositionFormGroup.get('customPosition')?.hasError('pattern')" class="custom1">
                    Ingresa solo <strong>números</strong>
                </mat-error>
                <mat-error *ngIf="customNumeroTanqueError" class="custom2">Introducir el número de tanque</mat-error>
            </form>

            <!--<mat-form-field class="etiqueta-container" style="margin-top: 0px;">
                <mat-label class="etiqueta-label">Nº de tanque</mat-label>
                <input matInput type="text" [(ngModel)]="nTanque">
                <button *ngIf="nTanque" matSuffix mat-icon-button aria-label="Clear" (click)="nTanque=''">
                  <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>-->

            <form [formGroup]="capacidadFormGroup"  class="marginTopM15">
                <mat-form-field class="etiqueta-container">
                    <mat-label class="etiqueta-label" [ngClass]="{'error-select': capacidadError}">Capacidad del tanque</mat-label>
                    <input matInput type="text" formControlName="capacidadTanque">
                </mat-form-field>
                <mat-error *ngIf="capacidadFormGroup.get('capacidadTanque')?.hasError('pattern')" class="custom1">
                    Ingresa solo <strong>números</strong>
                </mat-error>
                <mat-error *ngIf="capacidadError" class="custom3">Introducir la capacidad</mat-error>
            </form>

            <div class="estado-container marginTop10">
                <span class="custom4" [ngClass]="{'error-select': cervezaError}">Cerveza: </span> <span> Tipo de cerveza</span>
                <mat-form-field class="custom5">
                    <mat-label>-Elige una opción-</mat-label>
                    <mat-select [formControl]="cervezasControl" name="est">
                      <mat-option *ngFor="let est of cervezas" [value]="est.value">
                        {{est.name}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-error *ngIf="cervezaError" class="custom6">Selecciona una cerveza</mat-error>
            </div>

        <!--CONFIGURACIÓN DE ALARMAS-->

            <div class="rango-alarmas-header">
                <span>CONFIGURACIÓN DE ALARMAS</span>
            </div>

            <form [formGroup]="configuracionAlarmas" class="marginTop30">
                <span class="custom4">Nivel: </span>
                <mat-form-field class="custom7">
                    <mat-label class="etiqueta-label">Nivel mínimo de cerveza (%)</mat-label>
                    <input matInput type="text" formControlName="nivelCerveza">
                </mat-form-field>
                <mat-error *ngIf="configuracionAlarmas.get('nivelCerveza')?.hasError('pattern')" class="custom1">
                    Ingresa solo <strong>números</strong>
                </mat-error>
                <mat-error *ngIf="configuracionAlarmas.get('nivelCerveza')?.hasError('min')" class="custom1">
                    El valor debe ser mayor o igual a <strong>0</strong>
                </mat-error>
                <mat-error *ngIf="configuracionAlarmas.get('nivelCerveza')?.hasError('max')"  class="marginTopM15">
                    El valor debe ser menor o igual a <strong>100</strong>
                </mat-error>
            </form>

            <div class="marginTop10">
                <span class="custom4">Temperatura: </span>
                <div class="custom8">
                    <form [formGroup]="configuracionAlarmas" class="custom9">
                        <mat-form-field class="etiqueta-container marginTop20">
                            <mat-label class="etiqueta-label">Mínimo (ºC)</mat-label>
                            <input matInput type="text" formControlName="temperaturaTanqueMin">
                        </mat-form-field>
                        <mat-error *ngIf="configuracionAlarmas.get('temperaturaTanqueMin')?.hasError('pattern')"  class="marginTopM15">
                            Ingresa solo <strong>números</strong>
                        </mat-error>
                    </form>
        
                    <form [formGroup]="configuracionAlarmas" class="width475">
                        <mat-form-field class="etiqueta-container marginTop20">
                            <mat-label class="etiqueta-label">Máximo (ºC)</mat-label>
                            <input matInput type="text" formControlName="temperaturaTanqueMax">
                        </mat-form-field>
                        <mat-error *ngIf="configuracionAlarmas.get('temperaturaTanqueMax')?.hasError('pattern')"  class="marginTopM15">
                            Ingresa solo <strong>números</strong>
                        </mat-error>
                    </form>
                </div>
            </div>

            <div class="marginTop15">
                <span class="custom4">Presión: </span>
                <div class="custom8">
                    <form [formGroup]="configuracionAlarmas" class="custom9">
                        <mat-form-field class="etiqueta-container marginTop20">
                            <mat-label class="etiqueta-label">Mínimo (Bares)</mat-label>
                            <input matInput type="text" formControlName="presionMin">
                        </mat-form-field>
                        <mat-error *ngIf="configuracionAlarmas.get('presionMin')?.hasError('pattern')"  class="marginTopM15">
                            Ingresa solo <strong>números</strong>
                        </mat-error>
                    </form>
        
                    <form [formGroup]="configuracionAlarmas" class="width475">
                        <mat-form-field class="etiqueta-container marginTop20">
                            <mat-label class="etiqueta-label">Máximo (Bares)</mat-label>
                            <input matInput type="text" formControlName="presionMax">
                        </mat-form-field>
                        <mat-error *ngIf="configuracionAlarmas.get('presionMax')?.hasError('pattern')"  class="marginTopM15">
                            Ingresa solo <strong>números</strong>
                        </mat-error>
                    </form>
                </div>
            </div>
        </div>

        <!--INSTALACION-->

        <div class="datos-dispositivo">
            <div class="datos-instalacion-header">
                <span>DATOS DE LA INSTALACIÓN</span>
            </div>

            <!--<div class="etiqueta-container">
                <span class="custom4" [ngClass]="{'error-select': dispositivoError}">Dispositivo: * </span>
                <mat-form-field class="custom5">
                    <mat-label [ngClass]="{'error-select': dispositivoError}">-Elige una opción-</mat-label>
                    <mat-select [(value)]="selectedDispositivo" name="dev" (selectionChange)="updateEstadoDispositivo()">
                        <mat-option *ngFor="let dev of devicesData" [value]="dev">
                        {{dev.dev_label}} ({{dev.dev_reference}})
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-error *ngIf="dispositivoError" style="margin-top: -10px; margin-bottom: 20px;">Selecciona un dispositivo</mat-error>
            </div>-->

            <div class="custom10">
                <span class="custom4" [ngClass]="{'error-select': dispositivoError}">Dispositivo: * </span>
                <form class="custom11">
                    <mat-form-field class="width100">
                        <mat-label>Dispositivo</mat-label>
                        <input type="text"
                                placeholder="Elige uno"
                                aria-label="Dispositivo"
                                matInput
                                [formControl]="myControl"
                                [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event)">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                {{ option.label }}
                            </mat-option>
                        </mat-autocomplete>
                        <button *ngIf="myControl.value != ''" matSuffix mat-icon-button aria-label="Clear" (click)="limpiarSeleccion()">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-error *ngIf="dispositivoError" class="custom12">Selecciona un dispositivo</mat-error>
                </form>
            </div>
            
            <div>
                <span class="custom4">Establecimiento: </span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10">
                    <input matInput type="text" [readonly]="true" value="{{establecimientoNombre}}"/>
                </mat-form-field>
            </div>

            <div class="marginBottom5">
                <mat-label class="etiqueta-label" [ngClass]="{'error-select': numeroTanqueError}">Posición: </mat-label> <span> Disponible en el dispositivo</span>
            </div>
            <mat-form-field class="etiqueta-container marginTopM5">
                <mat-label [ngClass]="{'error-select': numeroTanqueError}">-Elige una numero-</mat-label>
                <mat-select [(ngModel)]="tanqueSeleccionado" [disabled]="slotsDisponibles.length === 0">
                    <mat-option *ngFor="let slot of slotsDisponibles" [value]="slot">{{ slot }}</mat-option>
                </mat-select>
                <mat-hint *ngIf="mostrarHint">Primero selecciona un dispositivo</mat-hint>
                <mat-error *ngIf="numeroTanqueError" class="custom6">Introducir la posición</mat-error>
            </mat-form-field>

            <div class="mapa-container marginTop20">
                <div class="marginBottom20">
                    <span class="custom4">Ubicación del establecimiento: </span>
                </div>
                <div id="map" class="height450"></div>
            </div>

            <div class="etiqueta-container">
                <span class="custom4">Dirección completa: </span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10" *ngIf="addressData">
                    <input matInput type="text" [readonly]="true" value="{{addressData}}"/>
                </mat-form-field>
                <mat-form-field appearance="outline" class="latitud-value marginTop10" *ngIf="!addressData">
                    <input matInput type="text" [readonly]="true" value="No hay datos disponibles"/>
                </mat-form-field>
            </div>

            <div class="input-container2" *ngIf="userData.pro_id == 4">
                <mat-label class="custom4" class="label-text">Cliente: </mat-label>
                <mat-form-field class="custom5">
                    <mat-label>-Elige una opción-</mat-label>
                    <mat-select [(value)]="selectedCliente" name="est">
                      <mat-option *ngFor="let est of clientes" [value]="est.value">
                        {{est.name}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
</div>
<div class="footer"></div>

